export default __webpack_public_path__ + "static/media/tejiajipiaobiaoqian.4920acbf.png";